export const RECOMMENDED_LEARNING_ACTIVITIES_ERROR = 'RECOMMENDED_LEARNING_ACTIVITIES_ERROR';
export const RECOMMENDED_LEARNING_ACTIVITIES_LOADING = 'RECOMMENDED_LEARNING_ACTIVITIES_LOADING';
export const RECOMMENDED_LEARNING_ACTIVITIES_GET = 'RECOMMENDED_LEARNING_ACTIVITIES_GET';
